export default "__VITE_ASSET__3GRiiL$l__"